import PropTypes from 'prop-types';
import React from 'react';

import './LeftRailLayout.scss';

export default class LeftRailLayout extends React.PureComponent {
    static propTypes = {
        /**
         * Prop to determine how layout falls in mobile view: 'main-content-on-top' OR 'rail-content-on-top'
         */
        mobileLayoutClass: PropTypes.string,
        showLeftRailMobile: PropTypes.bool,
    };

    static defaultProps = {
        showLeftRailMobile: true,
        mobileLayoutClass: 'main-content-on-top',
    };

    static LeftRail = ({ children }) => (
        <div className="LeftRailLayout-LeftRail">{children}</div>
    );

    static MainContent = ({ children, className = '' }) => (
        <div className={`LeftRailLayout-MainContent ${className}`}>
            {children}
        </div>
    );

    render() {
        const showLeftRailMobileClass = this.props.showLeftRailMobile
            ? ''
            : 'hide-left-rail-on-mobile';
        return (
            <div
                className={`component-LeftRailLayout ${this.props.mobileLayoutClass} ${showLeftRailMobileClass}`}
            >
                {this.props.children}
            </div>
        );
    }
}
